<template>
    <div>
        <page-header title="Shipments" breadcrumb="Bookings & Shipments  >  Shipments" :back="back" />

        <div class="card table-header mt-4">
            <div class="flex justify-between">
                <div class="group-options-select">
                    <div class="flex" v-if="currentTab != 'incident'">
                        <div class="mr-2 shadow-table p-2 filter">
                            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
                        </div>
                        <div class="table__search-input-wrapper">
                            <span class="pr-2 opacity-50"><search-icon /> </span>
                            <input type="text" class="table__search-input" placeholder="Search..." v-model="query" />
                            <img src="@/assets/images/icons/search.svg" alt="search icon" />
                        </div>
                    </div>
                </div>

                <div class="flex gap-4">
                    <span class="shadow-table rounded-md p-2">Bulk Actions</span>
                    <base-button text="Apply" />
                    <button class="shadow-table rounded-md p-2">
                        <img src="@/assets/images/icons/print-icon.svg" alt="print icon" />
                    </button>
                    <button class="shadow-table rounded-md p-2">
                        <img src="@/assets/images/icons/refresh-icon.svg" alt="refresh icon" />
                    </button>
                </div>
            </div>

            <div class="responsive-table" id="table-wrapper">
                <table class="custom-table responsive-table border-collapse">
                    <thead>
                        <tr class="shadow-table rounded-lg">
                            <th>
                                <base-checkbox />
                            </th>
                            <th>Shipping Ref</th>
                            <th>Booking Channel</th>
                            <th>Shipper</th>
                            <th>Consignee</th>
                            <th>Pick-up Date</th>
                            <th>Est. Drop Date</th>
                            <th>Status</th>
                            <th tabindex="-1">
                                <span class="cursor-pointer">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <g opacity="0.7">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                                                fill="#383F51" />
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                                                fill="#383F51" />
                                        </g>
                                    </svg></span>
                            </th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <tr 
                        v-for="i in [0,1,2,3,4,5,6,7,8,9]"
                        :key="i"
                        class="shadow-table rounded-lg">
                            <td>
                                <base-checkbox />
                            </td>
                            <td>MX000323</td>
                            <td>GIG Logistics</td>
                            <td>Israel Ndu</td>
                            <td>Ngozi Odogwu</td>
                            <td>13/02/2021
                                04:00pm</td>
                            <td>13/02/2021
                                04:00pm</td>
                            <td 
                            class="capitalize text-base"
                            >
                            <badge :class="colorSpec('delivered')">
                                Delivered
                             </badge>
                            </td>
                            <td tabindex="-1" @blur="selectedRowId = null" class="table__action-btn cursor-pointer">
                                <span @click="showActionOptions(i)">
                                    <vertical-ellipsis />
                                </span>
                                <div class="table__action-options w-64" v-if="selectedRowId == i">
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                       Accept
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Decline
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Cancel Pickup
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Process Hand-Off
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Create Return Shipment
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Upload Doc
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Update Status
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Send Message
                                    </div>
                                    <div class="item-action"
                                    @click="showRequestAssistanceFunc"
                                    >
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Request Assistance
                                    </div>
                                    <div class="item-action"
                                    @click="reportIncedent = true"
                                    >
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Report an Incident
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-2">
                                        Enable Auto-Tracking
                                        Notification
                                    </div>
                                    <div class="item-action">
                                        <img src="@/assets/images/icons/hand-up.png" class="mr-1">
                                        View Details
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
            <pagination-control />
            <RequestAssistanceModal v-model="showRequestAssistance" :showModal="showRequestAssistance" @closeModal="showRequestAssistance = false"/>
            <ReportIncedent v-model="reportIncedent" :showModal="reportIncedent" @closeModal="reportIncedent = false"/>
            <SearchMap v-model="showSearchMap" :showModal="showSearchMap" @closeModal="showSearchMap = false"/>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import PaginationControl from "@/components/UI/NewPagination";
import RequestAssistanceModal from "./Modals/RequestAssistance"
import ReportIncedent from "./Modals/ReportIncedent"
import SearchMap from "./Modals/SearchMap"


export default {
    components: {
        PageHeader,
        PaginationControl,
        RequestAssistanceModal,
        ReportIncedent,
        SearchMap
    },
    props: ['back'],
    data() {
        return {
            query: "",
            count: {},
            selectedRowId: null,
            showRequestAssistance: false,
            reportIncedent: false,
            showSearchMap: false
        };
    },
    watch: {

    },
    mounted() {
    },
   methods: {
    showRequestAssistanceFunc(){
        this.showRequestAssistance = true
    },
    colorSpec(status) {
    switch (status) {
      case 'delivered':
        return "text-primary-green bg_green"
      case 'in-transit':
        return "text-primary-green bg_green"
      case 'accepted':
        return "text-primary-green bg_green"
      case "pending":
        return "text-primary-yellow bg_yellow"
      default:
        return "text-red-600 bg_red"
    }
  },
    showActionOptions(id) {
      if (id) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
   },
};
</script>

<style lang="scss" scoped>
.item-action{
    @apply px-2 flex items-center py-1
}
.bg_green {
    background-color: rgba(9, 183, 138, 0.1)
  }
  
  .bg_yellow {
    background-color: rgba(252, 194, 16, 0.1)
  }
  
  .bg_red {
    background-color: rgba(229, 62, 62, 0.1)
  }
  
  .sub_abbr {
    @apply opacity-50 text-sm font-normal block w-full;
  }
.table__action-btn {
    position: relative;
    padding: 0;
    /* display: flex;
    height: 100%;
    justify-content: center;
    align-items: center; */
  }
  .table__action-options {
    position: absolute;
    width: 12rem;
    /* height: 7rem; */
    padding: 0.5rem 0;
    right: 2rem;
    background: #ffffff;
    z-index: 999;
    border-radius: 3px;
    box-shadow: 0px 0px 12px #dee0e7;
  }
  .table__action-option {
    padding: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }
  .table__action-option:hover {
    background: #fce4da;
  }
  .table__action-btn span {
    width: 100%;
  }
.tab-item {
    cursor: pointer;
    // margin-right: 1rem;
    color: #5e646d;
    padding: 0.25rem 1.5rem;
    font-size: 0.9rem;

    &.active {
        background: #ffffff;
        box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
        border-radius: 5px;
        color: #fcc210;
        font-weight: bold;
    }
}
</style>